/**************************************************
 * Nombre:       Tarjeta_Banner_Portada
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";

const Tarjeta_Banner_Portada = ({item}) => {
    const {sCell, sTab} = useResponsive()

    console.log(item)
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundImage: sCell && item.imgCell ? `linear-gradient(180deg, #000 0%, rgba(0, 0, 0, 0.00) 59.46%), url(${item.imgCell})` :
                    `linear-gradient(180deg, #000 0%, rgba(0, 0, 0, 0.00) 59.46%), url(${item.img})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
                p: 2,
                mt: 4,
                width: '100%',
            }}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: sTab ? 40 : 66, mb: 4}}>
                {item.nombre &&
                    <Button
                        href={item.link}
                        sx={{
                            backgroundColor: '#ffffff40',
                            border: 1,
                            borderColor: '#fff',
                            backdropFilter: 'blur(2px)',
                            boxShadow: 0,
                            px: 4
                        }}
                    >{item.nombre}</Button>
                }
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Banner_Portada    